import { RouteNameEnum } from '@/router/RouteName';
import { isRouteNameInRoute, logGuard } from '@/router/helpers';
import { User } from '@/models/User';
import { Token } from '@/support/Token';
export const authMiddleware = async (to, _from) => {
    logGuard('[AUTH_MIDDLEWARE]', to);
    if (to.query.token) {
        Token.set(to.query.token);
    }
    const user = await User.attemptLogin()
        .catch((error) => {
        const errorStatus = error.response
            && error.response.status
            ? error.response.status
            : undefined;
        const errorMessage = error
            && error.response
            && error.response.data
            && error.response.data.message
            ? error.response.data.message
            : undefined;
        // console.log('[AUTH_MIDDLEWARE] errorStatus', errorStatus, 'errorMessage', errorMessage);
        // if (errorStatus === 403 && errorMessage === 'De gebruiker moet eerst een MFA token instellen') {
        //   // console.log('[AUTH_MIDDLEWARE] throwing custom error');
        //   throw(new Error('CUSTOM ERROR: De gebruiker moet eerst een MFA token instellen'));
        // }
    });
    if (!user) {
        logGuard('[AUTH_MIDDLEWARE], no user');
        return isRouteNameInRoute(RouteNameEnum.LOGIN, to)
            ? true
            : { name: RouteNameEnum.LOGIN, query: { redirect: to.fullPath } };
    }
    if (!user.hasValidMfa()) {
        logGuard('[AUTH_MIDDLEWARE], no valid mfa');
        return isRouteNameInRoute(RouteNameEnum.SET_MFA, to)
            ? true
            : { name: RouteNameEnum.SET_MFA, query: { redirect: to.fullPath } };
    }
    logGuard('[AUTH_MIDDLEWARE] returning true');
    return true;
};
